import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number | undefined }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      const val = params[key];
      if (val !== undefined && val !== null && val !== "") {
        queryParams.append(key, String(val));
      }
    });
  }
  const query = queryParams.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}

function getWebhookLogs(params: {
  skip?: number;
  limit?: number;
  platform?: string;
  status?: string;
  sellerId?: string;
}) {
  const baseUrl = "webhook-logs";
  const url = buildUrl(baseUrl, params as Record<string, string | number>);
  return getApiInstance().get(url);
}

function getWebhookLog(id: string) {
  const baseUrl = "webhook-logs";
  const url = `${baseUrl}/${id}`;
  return getApiInstance().get(url);
}

export { getWebhookLogs, getWebhookLog };
